import { InvoiceAdjustmentUpsertDto } from '../../dto/invoice-adjustment-upsert.dto';
import { InvoiceLineItemUpsertDto } from '../../dto/invoice-line-item-upsert.dto';
import { RevenueObservationService } from '../../../revenue/shared/revenue-observation.service';
import { InvoiceUpsertDto } from '../../dto/invoice-upsert.dto';
import { Component, OnInit, Input, SimpleChanges, OnChanges, Output, EventEmitter } from '@angular/core';
import { InvoiceUtilityService } from 'src/app/revenue/shared/invoice/invoice-utility/invoice-utility.service';

@Component({
  selector: 'wl-invoice-summary',
  templateUrl: './invoice-summary.component.html',
  styleUrls: ['./invoice-summary.component.less'],
    standalone: false
})
export class InvoiceSummaryComponent implements OnInit, OnChanges {
  @Input() invoice: InvoiceUpsertDto;
  @Input() isEditable = true;
  @Input() relatedModification = false;
  @Output() updatedBalance = new EventEmitter<number>();

  public invoiceTotal = 0;
  public paymentTotal = 0;
  public balance = 0;

  constructor(private _revenueObservationService: RevenueObservationService, private _invoiceUtilityService: InvoiceUtilityService) {}

  ngOnInit() {
    this._revenueObservationService.observeInvoiceAmountChanged().subscribe((invoiceNum) => {
      if (invoiceNum === this.invoice.InvoiceHeader.InvoiceNum) {
        this.calculateTotals();
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.invoice || changes.relatedModification) {
      this.calculateTotals();
    }
  }

  private calculateTotals() {
    const { totalCost, amountPaid, balance } = this._invoiceUtilityService.calculateInvoiceTotals(this.invoice);

    this.invoiceTotal = totalCost;
    this.paymentTotal = amountPaid;
    this.balance = balance;
    this.updatedBalance.emit(this.balance);
  }
}
